import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { testimonialsData } from '../../mock';
import { fadeUp, staggerContainer, viewport } from '../../lib/motion';

export default function Testimonials() {
  return (
    <section className="px-6 lg:px-10 py-28 bg-ink-800">
      <div className="max-w-7xl mx-auto">
        <motion.div variants={staggerContainer()} initial="hidden" whileInView="show" viewport={viewport} className="text-center max-w-2xl mx-auto mb-16">
          <motion.span variants={fadeUp} className="text-xs tracking-[0.2em] uppercase font-semibold text-gold-light">Testimonials</motion.span>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl text-white tracking-tight mt-3">Trusted by business leaders</motion.h2>
        </motion.div>

        <motion.div variants={staggerContainer(0.12)} initial="hidden" whileInView="show" viewport={viewport} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonialsData.map((t) => (
            <motion.div key={t.id} variants={fadeUp} whileHover={{ y: -6 }} data-testid={`testimonial-card-${t.id}`} className="bg-ink-900 border border-slate-800 hover:border-gold/40 rounded-3xl p-8 flex flex-col transition-colors">
              <Quote className="w-9 h-9 text-gold/40 mb-5" strokeWidth={1.25} />
              <p className="font-display italic text-lg text-slate-200 leading-relaxed flex-1">"{t.content}"</p>
              <div className="flex text-gold-light my-5">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-light" strokeWidth={0} />)}
              </div>
              <div className="flex items-center gap-4 pt-5 border-t border-slate-800">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-gold/40" />
                <div>
                  <h4 className="text-white font-medium text-sm">{t.name}</h4>
                  <p className="text-xs text-slate-400">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
